export default "__VITE_ASSET__e728c43f__"